"use strict";
var $ = require("../internals/export");
var createHTML = require("../internals/create-html");
var forcedStringHTMLMethod = require("../internals/string-html-forced");
$({ target: "String", proto: true, forced: forcedStringHTMLMethod("fontcolor") }, {
  fontcolor: function fontcolor(color) {
    return createHTML(this, "font", "color", color);
  }
});
